module.exports = __webpack_public_path__ + "static/media/cup.82569ac0.svg";